export const defaultState = () => {
    return {
        current: {},
        selected: null,
        clickedSave: false,
        editResponsesMode: false,
        editingFollowupResponses: false,
        comprehensive: true,
        streamlinedOptions: [],
        thresholdSet: null,
        filterConditions: [],
    }
}

const state = defaultState()
export default state
